import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import Exploration from '@/components/Exploration'
import Presentation from '@/components/Presentation'
import Explore from '@/components/Explore'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'Dashboard' }
    },
    {
      path: '/dashboard/:mode?/:id?',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/exploration/:id/:mode/:slug?',
      name: 'Exploration',
      component: Exploration
    },
    {
      path: '/presentation/:id',
      name: 'Presentation',
      component: Presentation
    },
    {
      path: '/explore/:id/:mode/:slug?',
      name: 'Explore',
      component: Explore
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js